import { render, staticRenderFns } from "./TheSidebar.vue?vue&type=template&id=4e3603dc&scoped=true&"
var script = {}
import style0 from "./TheSidebar.vue?vue&type=style&index=0&id=4e3603dc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e3603dc",
  null
  
)

export default component.exports